import { Grid, Stack, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import UpdateRepresentativeInformation from './components/update-business-information-components/update-representative-information.component';
import UpdateSettlementDetails from './components/update-business-information-components/update-settlement-details.component';
import { UpdateMerchantOnboardingFormValues } from '../../type/update-merchant-onboarding-form-values.types';
import UpdateUploadDocuments from './components/update-business-information-components/update-upload-documents.component';

interface UpdateBusinessInformationProps {
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>;
  isNonAdminInterface: boolean;
}
function UpdateBusinessInformation(props: UpdateBusinessInformationProps) {
  const { form, isNonAdminInterface } = props;

  return (
    <>
      <Stack>
        <Text size='xl' weight={700}>
          Business Information
        </Text>
        <Grid>
          <Grid.Col>
            <UpdateRepresentativeInformation
              form={form}
              representativeInformation={true}
              isNonAdminInterface={isNonAdminInterface}
            />
          </Grid.Col>
          {!isNonAdminInterface && (
            <Grid.Col>
              <UpdateRepresentativeInformation
                form={form}
                representativeInformation={false}
              />
            </Grid.Col>
          )}

          <Grid.Col>
            <UpdateSettlementDetails form={form} />
          </Grid.Col>
          <Grid.Col>
            <UpdateUploadDocuments
              form={form}
              businessTypeId={form.values.businessTypeId}
            />
          </Grid.Col>
        </Grid>
      </Stack>
    </>
  );
}

export default UpdateBusinessInformation;
